import { PureComponent } from 'preact-compat'

import { IdeaStatus } from '../interfaces'

export interface TopicPillsProps {
  trashed: boolean
  spam: boolean
  pending: boolean
  publicLabel?: string | null
  ideationStatus?: IdeaStatus
  author?: boolean
}

class TopicPills extends PureComponent<TopicPillsProps> {
  render() {
    const { trashed, spam, ideationStatus, publicLabel, pending, author } = this.props
    return (
      <div className='pill-container'>
        {trashed && <span className='pill pill--trashed'>trashed</span>}
        {pending && <span className='pill pill--pending'>pending</span>}
        {ideationStatus && (
          <span
            className='idea-status-pill'
            style={{
              color: `#${ideationStatus.textColor}`,
              backgroundColor: `#${ideationStatus.backgroundColor}`
            }}
          >
            {ideationStatus.name}
          </span>
        )}
        {publicLabel && <span className='pill pill-article-label'>{publicLabel}</span>}
        {spam && <span className='pill pill--spam'>spam</span>}
        {author && <span className='pill pill--author'>author</span>}
      </div>
    )
  }
}

export default TopicPills
